/**
 * German translations
 *
 * Machine-translated - requires professional review
 */
import type { TranslationStructure } from '../types';

export const de: TranslationStructure = {
  common: {
    appName: 'Dashboard',
    loading: 'Laden...',
    loadingDashboard: 'Dashboard wird geladen...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    adding: 'Wird hinzugefügt...',
    create: 'Erstellen',
    update: 'Aktualisieren',
    submit: 'Absenden',
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Information',
    all: 'Alle',
    none: 'Keine',
    search: 'Suchen',
    filter: 'Filtern',
    filters: 'Filter',
    reset: 'Zurücksetzen',
    refresh: 'Aktualisieren',
    download: 'Herunterladen',
    upload: 'Hochladen',
    view: 'Ansehen',
    details: 'Details',
    actions: 'Aktionen',
    status: 'Status',
    date: 'Datum',
    time: 'Zeit',
    name: 'Name',
    email: 'E-Mail',
    description: 'Beschreibung',
    notes: 'Notizen',
    type: 'Typ',
    user: 'Benutzer',
    role: 'Rolle',
    organization: 'Organisation',
    required: 'Erforderlich',
    optional: 'Optional',
    notAvailable: 'N/V',
    other: 'Sonstige',
    goBack: 'Zurück',
  },

  roles: {
    admin: 'Administrator',
    pilot: 'Pilot',
    maintenance: 'Wartung',
    airspace_observer: 'Luftraumbeobachter',
  },

  profile: {
    myProfile: 'Mein Profil',
    userProfile: 'Benutzerprofil',
    loadError: 'Profil konnte nicht geladen werden',
    notFound: 'Profil nicht gefunden',
    bio: 'Über mich',
    bioPlaceholder: 'Erzählen Sie uns etwas über sich...',
    noBio: 'Noch keine Biografie hinzugefügt.',
    bioSaved: 'Biografie erfolgreich gespeichert',
    bioSaveError: 'Biografie konnte nicht gespeichert werden',
    fullName: 'Vollständiger Name',
    noName: 'Kein Name festgelegt',
    nameSaved: 'Name erfolgreich gespeichert',
    nameSaveError: 'Name konnte nicht gespeichert werden',
    certifications: 'Zertifizierungen',
    noCertifications: 'Noch keine Zertifizierungen hinzugefügt.',
    addCertification: 'Zertifizierung hinzufügen',
    certificationName: 'Name der Zertifizierung',
    expiryDate: 'Ablaufdatum',
    uploadDocument: 'Dokument hochladen',
    certificationAdded: 'Zertifizierung erfolgreich hinzugefügt',
    certificationAddError: 'Zertifizierung konnte nicht hinzugefügt werden',
    certificationRemoved: 'Zertifizierung erfolgreich entfernt',
    certificationRemoveError: 'Zertifizierung konnte nicht entfernt werden',
    expired: 'Abgelaufen',
    expiresOn: 'Läuft ab am',
    deletePicture: 'Bild löschen',
    pictureUploaded: 'Profilbild erfolgreich hochgeladen',
    pictureUploadError: 'Profilbild konnte nicht hochgeladen werden',
    pictureDeleted: 'Profilbild erfolgreich gelöscht',
    pictureDeleteError: 'Profilbild konnte nicht gelöscht werden',
    memberSince: 'Mitglied seit',
    totalPilotHours: 'Gesamte Flugstunden als Pilot',
  },

  auth: {
    signIn: 'Anmelden',
    signOut: 'Abmelden',
    signingOut: 'Abmelden...',
    loginSuccessful: 'Anmeldung erfolgreich',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    fullName: 'Vollständiger Name',
    forgotPassword: 'Passwort vergessen?',
    backToLogin: 'Zurück zur Anmeldung',
    authenticationRequired: 'Authentifizierung erforderlich',
    invitationOnly:
      'Der Zugang erfolgt nur auf Einladung. Bitten Sie einen Administrator Ihrer Organisation, Sie einzuladen.',
    emailRequired: 'E-Mail ist erforderlich',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    passwordRequired: 'Passwort ist erforderlich',
    passwordMinLength: 'Passwort muss mindestens 6 Zeichen lang sein',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    fullNameRequired: 'Vollständiger Name ist erforderlich',
    pendingApproval:
      'Ihr Konto wartet auf Genehmigung. Bitte kontaktieren Sie einen Administrator, um einer Organisation zugewiesen zu werden, bevor Sie sich anmelden können.',
  },

  passwordReset: {
    title: 'Passwort zurücksetzen',
    verifyCode: 'Code verifizieren',
    setNewPassword: 'Neues Passwort festlegen',
    emailPrompt: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Verifizierungscode.',
    codeSentTo: 'Geben Sie den 6-stelligen Code ein, der an {{email}} gesendet wurde',
    newPasswordPrompt: 'Geben Sie unten Ihr neues Passwort ein.',
    sendVerificationCode: 'Verifizierungscode senden',
    verificationCode: 'Verifizierungscode',
    codeHelperText: 'Geben Sie den 6-stelligen Code aus Ihrer E-Mail ein',
    verifyCodeButton: 'Code verifizieren',
    resendCode: 'Code erneut senden',
    resendCodeIn: 'Code erneut senden in {{seconds}}s',
    changeEmail: 'E-Mail ändern',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    passwordHelperText: 'Muss mindestens 6 Zeichen haben',
    resetPasswordButton: 'Passwort zurücksetzen',
    updatingPassword: 'Passwort wird aktualisiert...',
    successTitle: 'Passwort erfolgreich zurückgesetzt!',
    successMessage:
      'Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
    redirecting: 'Sie werden in Kürze zur Anmeldeseite weitergeleitet...',
    processUpdatedTitle: 'Zurücksetzungsprozess aktualisiert',
    processUpdatedMessage:
      'Unser Passwort-Zurücksetzungsprozess wurde aktualisiert. Wir verwenden jetzt Verifizierungscodes anstelle von magischen Links für bessere Sicherheit und Kompatibilität.',
    instructionsTitle: 'Um Ihr Passwort zurückzusetzen:',
    instruction1: 'Klicken Sie auf die Schaltfläche unten, um zur Zurücksetzungsseite zu gelangen',
    instruction2: 'Geben Sie Ihre E-Mail-Adresse ein',
    instruction3:
      'Geben Sie den 6-stelligen Verifizierungscode ein, der an Ihre E-Mail gesendet wurde',
    instruction4: 'Legen Sie Ihr neues Passwort fest',
    goToPasswordReset: 'Zur Passwort-Zurücksetzung',
    autoRedirect: 'Sie werden in 5 Sekunden automatisch weitergeleitet...',
    codeRequired: 'Verifizierungscode ist erforderlich',
    codeMustBe6Digits: 'Verifizierungscode muss 6 Ziffern haben',
    invalidCode: 'Ungültiger oder abgelaufener Verifizierungscode',
    codeSent: 'Verifizierungscode an Ihre E-Mail gesendet.',
    codeResent: 'Verifizierungscode erneut an Ihre E-Mail gesendet.',
    codeVerified: 'Code erfolgreich verifiziert!',
    passwordUpdated: 'Passwort erfolgreich aktualisiert!',
  },

  invitation: {
    validating: 'Einladung wird validiert...',
    invalidTitle: 'Ungültige Einladung',
    invalidMessage:
      'Diese Einladung ist möglicherweise abgelaufen oder wurde bereits verwendet. Bitte kontaktieren Sie den Administrator Ihrer Organisation, um eine neue Einladung anzufordern.',
    goToLogin: 'Zur Anmeldung',
    acceptTitle: 'Einladung annehmen',
    invitedTo: 'Sie wurden eingeladen, {{organization}} beizutreten',
    enterFullName: 'Geben Sie Ihren vollständigen Namen ein',
    createAccountButton: 'Konto erstellen und Organisation beitreten',
    creatingAccount: 'Konto wird erstellt...',
    successTitle: 'Konto erfolgreich erstellt!',
    accountCreated: 'Konto erfolgreich erstellt. Sie können sich jetzt anmelden.',
    welcomeMessage:
      'Willkommen bei {{organization}}! Ihr Konto ist bereit. Sie werden in Kürze zur Anmeldeseite weitergeleitet.',
    redirectingToLogin: 'Sie werden in Kürze zur Anmeldeseite weitergeleitet...',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    signInHere: 'Hier anmelden',
    noToken: 'Kein Einladungstoken angegeben',
    invalidData: 'Ungültige Einladungsdaten',
    userCreationFailed:
      'Konto erstellt, aber Benutzer-ID nicht zurückgegeben. Bitte versuchen Sie sich anzumelden.',
  },

  noOrganization: {
    title: 'Konto wartet auf Genehmigung',
    message:
      'Ihr Konto wurde erfolgreich erstellt! Bitte kontaktieren Sie einen Administrator, um einer Organisation zugewiesen zu werden, bevor Sie auf das Wartungspanel zugreifen können.',
    loggedInAs: 'Angemeldet als: {{email}}',
  },

  header: {
    plotFlightData: 'Flugdaten darstellen',
    adminTools: 'Admin-Werkzeuge',
  },

  tabs: {
    overview: 'Übersicht',
    files: 'Dateien',
    profile: 'Profil',
    maintenance: 'Wartung',
    healthPanel: 'Gesundheitspanel',
    inventory: 'Inventar',
    calendar: 'Kalender',
  },

  filterDialog: {
    fileFilters: 'Dateifilter',
    droneSerial: 'Drohnen-Seriennummer',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    resetFileFilters: 'Dateifilter zurücksetzen',
    sortOptions: 'Sortieroptionen',
    sortBy: 'Sortieren nach',
    sortByName: 'Name',
    sortByDate: 'Datum',
    sortBySerial: 'Drohnen-Seriennummer',
    ascending: 'Aufst.',
    descending: 'Abst.',
  },

  overview: {
    fleetOverview: 'Flottenübersicht',
    fleetSummary: 'Flottenzusammenfassung',
    totalDrones: 'Gesamtzahl Drohnen',
    totalEngineHours: 'Gesamte Motorstunden',
    totalFlightHours: 'Gesamte Flugstunden',
    allDrones: 'Alle Drohnen',
    clickToViewProfile: 'Klicken Sie auf eine Drohnenkarte, um das Profil anzuzeigen',
    noDronesFound: 'Keine Drohnen für Ihre Organisation gefunden',
    latestFlights: 'Letzte Flüge',
    noFlightsRecorded: 'Noch keine Flüge aufgezeichnet',
    failedToLoadFlights: 'Letzte Flüge konnten nicht geladen werden',
    drone: 'Drohne',
    maintenance: 'Wartung',
    flightHours: 'Flugstunden',
    engineHours: 'Motorstunden',
    overdue: 'ÜBERFÄLLIG: {{hours}}h',
    next: 'Nächste: {{hours}}h',
    personnel: {
      title: 'Personalübersicht',
      pilots: 'Piloten',
      maintenanceEngineers: 'Wartungsingenieure',
      noPilots: 'Keine Piloten in Ihrer Organisation gefunden',
      noMaintenanceEngineers: 'Keine Wartungsingenieure in Ihrer Organisation gefunden',
      unnamed: 'Unbenannt',
      roles: {
        pilot: 'Pilot',
        maintenance: 'Wartung',
      },
    },
  },

  droneStatus: {
    airworthy: 'Lufttüchtig',
    airworthyTooltip: 'Drohne ist lufttüchtig und betriebsbereit',
    airworthyWithLimitations: 'Lufttüchtig mit Einschränkungen',
    airworthyWithLimitationsTooltip:
      'Drohne ist lufttüchtig, hat aber betriebliche Einschränkungen',
    maintenance: 'Wartung',
    maintenanceTooltip: 'Drohne befindet sich derzeit in Wartung',
    notAirworthy: 'Nicht lufttüchtig',
    notAirworthyTooltip: 'Drohne ist nicht lufttüchtig und kann nicht betrieben werden',
    withCustomer: 'Beim Kunden',
    withCustomerTooltip: 'Drohne ist derzeit beim Kunden',
    inProduction: 'In Produktion',
    inProductionTooltip: 'Drohne wird gefertigt oder montiert und ist noch nicht im Einsatz',
    failedToUpdate: 'Drohnenstatus konnte nicht aktualisiert werden',
  },

  // Drone Picture
  dronePicture: {
    failedToUpload: 'Drohnenbild konnte nicht hochgeladen werden',
  },

  profileTab: {
    selectDrone: 'Wählen Sie eine Drohne, um Statistiken anzuzeigen',
    droneInformation: 'Drohneninformationen',
    plotData: 'Daten darstellen',
    totalFiles: 'Gesamtzahl Dateien',
    firstFlight: 'Erster Flug',
    firstEngineRun: 'Erster Motorstart',
    engineStarts: 'Motorstarts',
    engineHours: 'Motorstunden',
    flightHours: 'Flugstunden',
    // #1612: the definition shown under the figure on the drone page.
    flightHoursDefinition:
      'Zeit in der Luft, aus dem Im-Flug-Signal des Flugloggers (Generatordrehzahl über 5.100 U/min, wo ein Log keines hat).',
    hoursBreakdown: '({{tracked}} erfasst + {{legacy}} Altbestand)',
    droneStatusLabel: 'Drohnenstatus',
    statusUpdated: 'Drohnenstatus auf {{status}} aktualisiert',
    invalidDate: 'Ungültiges Datum',
    ownershipLabel: 'Eigentum',
    ownershipSold: 'Verkauft',
    ownershipLeased: 'Geleast',
    leaseEnds: 'endet',
    failedToLoadStatus: 'Drohnenstatus konnte nicht geladen werden',
  },

  dronePageShared: {
    sharedBy: 'Freigegeben von {{org}}',
    sharedByUnknown: 'Von einer anderen Organisation freigegeben',
    countersIncludeSharedOne: 'Enthält {{count}} von {{orgs}} freigegebenen Flug',
    countersIncludeSharedOther: 'Enthält {{count}} von {{orgs}} freigegebene Flüge',
    timelineShared: 'Enthält freigegebene Flüge: {{orgs}}',
    trendPointShared: 'Freigegeben von {{org}}',
  },

  technicalSpecs: {
    title: 'Technische Spezifikationen',
    subtitle: 'Konfiguration, Software, Seriennummern und Optionen',
    configuration: 'Konfiguration',
    software: 'Software',
    serialNumbers: 'Seriennummern',
    options: 'Optionen',
    updatedSuccessfully: '{{field}} erfolgreich aktualisiert',
    failedToUpdate: 'Technische Spezifikation konnte nicht aktualisiert werden',
    tempSensorCableClip: 'Befestigungsclip des Temperatursensorkabels',
    notSet: 'Nicht festgelegt',
  },

  notes: {
    title: 'Notizen',
    notesFor: 'Notizen für {{serial}}',
    summary: '{{total}} gesamt • {{unresolved}} ungelöst • {{resolved}} gelöst',
    filters: 'Filter',
    createNote: 'Notiz erstellen',
    search: 'Suchen',
    type: 'Typ',
    allTypes: 'Alle Typen',
    general: 'Allgemein',
    customerFeedback: 'Kundenfeedback',
    alert: 'Warnung',
    priority: 'Priorität',
    allPriorities: 'Alle Prioritäten',
    information: 'Information',
    critical: 'Kritisch',
    includeResolved: 'Gelöste einschließen',
    selectDroneToView: 'Wählen Sie eine Drohne, um Notizen anzuzeigen',
    noNotesFound: 'Keine Notizen gefunden',
    createFirstNote: 'Erstellen Sie Ihre erste Notiz',
    addNote: 'Notiz hinzufügen',
    failedToLoad: 'Notizen konnten nicht geladen werden',
    failedToCreate: 'Notiz konnte nicht erstellt werden',
    failedToUpdate: 'Notiz konnte nicht aktualisiert werden',
    failedToDelete: 'Notiz konnte nicht gelöscht werden',
    failedToResolve: 'Notiz konnte nicht als gelöst markiert werden',
    failedToUnresolve: 'Notiz konnte nicht als ungelöst markiert werden',
  },

  maintenanceTab: {
    selectDrone: 'Wählen Sie eine Drohne, um Wartungsaufzeichnungen anzuzeigen',
    upcomingMaintenance: 'Anstehende Wartung',
    addMaintenance: 'Wartung hinzufügen',
    maintenanceHistory: 'Wartungshistorie',
    componentMaintenanceSchedule: 'Komponenten-Wartungsplan',
    visualInspectionSchedule: 'Sichtprüfungsplan',
    noUpcoming: 'Keine anstehende Wartung geplant',
    noHistory: 'Keine Wartungshistorie verfügbar',

    // Schedule card
    overdue: 'ÜBERFÄLLIG',
    dueIn: 'Fällig in:',
    hrsOverdue: '{{hours}} Std. überfällig',
    hrs: '{{hours}} Std.',
    trackingOnly: 'Nur Erfassung',
    hrsAccumulated: '{{hours}} Std. erfasst',
    viewMaintenanceManual: 'Wartungshandbuch anzeigen',
    viewInspectionInstructions: 'Inspektionsanweisungen anzeigen',

    // Historical/Record card
    performedBy: 'Durchgeführt von:',
    addedBy: 'Hinzugefügt von:',
    reviewedBy: 'Geprüft von:',
    qualityChecked: 'Qualitätsgeprüft',
    workOrderId: 'Arbeitsauftrags-ID:',
    unknown: 'Unbekannt',

    // Record statuses
    statusCompleted: 'Abgeschlossen',
    statusCancelled: 'Abgebrochen',
    statusPending: 'Ausstehend',

    // View dialog
    workDescription: 'Arbeitsbeschreibung',
    qualityCheckedBy: 'Qualitätsgeprüft von:',
    deleteMaintenanceRecord: 'Wartungsaufzeichnung löschen',
    deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Wartungsaufzeichnung löschen möchten?',
    deleteRecalculationWarning:
      'Diese Aktion löst eine automatische Neuberechnung der Wartungszähler für Drohne aus',
    deleteSuccess: 'Wartungsaufzeichnung erfolgreich gelöscht',
    deleteFailed: 'Fehler beim Löschen der Wartungsaufzeichnung. Bitte versuchen Sie es erneut.',

    // Record form
    startDate: 'Startdatum:',
    endDate: 'Enddatum:',
    startDateLabel: 'Startdatum',
    endDateLabel: 'Enddatum',
    maintenancePerformed: 'Wartung durchgeführt',
    unknownUser: 'Unbekannter Benutzer',
    differentUserRequired: '(Anderer Benutzer erforderlich)',
    failedToOpenManual: 'Wartungshandbuch konnte nicht geöffnet werden',
    failedToLoadTimeline: 'Wartungszeitplan konnte nicht geladen werden',
    failedToDownloadAttachment: 'Anhang konnte nicht heruntergeladen werden',
  },

  // Statistics mutations
  statistics: {
    failedToFetchWeather: 'Wetterdaten konnten nicht abgerufen werden',
    failedToUpdateFlight: 'Flugmetadaten konnten nicht aktualisiert werden',
    failedToUploadAttachment: 'Anhang konnte nicht hochgeladen werden',
  },

  filesTab: {
    title: 'Dateien',
    uploadFile: 'Datei hochladen',
    noFiles: 'Keine Dateien gefunden',
    fileName: 'Dateiname',
    fileSize: 'Größe',
    uploadedBy: 'Hochgeladen von',
    uploadedAt: 'Hochgeladen am',
    downloadFile: 'Datei herunterladen',
    deleteFile: 'Datei löschen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Datei löschen möchten?',
  },

  fileManagement: {
    title: 'Dateiverwaltung',
    root: 'Stammverzeichnis',
    sharedFolderChip: 'Mit Ihnen geteilt',
    backToShared: 'Zurück zu Geteilt',
    folderNotFoundTitle: 'Ordner nicht gefunden',
    folderNotFoundBody:
      'Dieser Link führt zu keinem Ordner, den Sie öffnen können. Er wurde möglicherweise gelöscht oder nie für Ihre Organisation freigegeben.',
    notAFolderTitle: 'Dieser Link verweist auf eine Datei',
    notAFolderBody:
      'Ordner-Links öffnen einen Ordner. Dieser benennt eine Datei, es gibt also nichts aufzulisten — öffnen Sie sie in dem Ordner, in dem sie liegt.',
    backToMyFiles: 'Zurück zu meinen Dateien',
    folderFileCount: '{{count}} Dateien',
    folderSerial: 'Drohne {{serial}}',
    showingOfTotal: '{{shown}} von {{total}} werden angezeigt',
    newFolder: 'Neuer Ordner',
    uploadFiles: 'Dateien hochladen',
    hideUpload: 'Upload ausblenden',
    documents: 'Dokumente',
    reports: 'Berichte',
    noFilesInDirectory: 'Keine Dateien in diesem Verzeichnis gefunden',
    moreActions: 'Weitere Aktionen',
    download: 'Herunterladen',
    downloadMany: 'Herunterladen ({{count}} Dateien)',
    bulkDownloadProgress: 'Lade {{done}} von {{total}} herunter...',
    bulkDownloadBrowserHint:
      'Ihr Browser fragt eventuell einmal, ob diese Seite mehrere Dateien herunterladen darf.',
    bulkDownloadDone: '{{count}} Downloads gestartet.',
    bulkDownloadPartial:
      '{{started}} von {{total}} Downloads gestartet. Nicht heruntergeladen: {{names}}',
    rename: 'Umbenennen',
    move: 'Verschieben',
    delete: 'Löschen',
    plot: 'Plotten',
    details: 'Details',
    moving: 'Verschieben: {{fileName}}',
    moveInstructions: 'Navigieren Sie zum Zielordner und klicken Sie auf "Hierher verschieben"',
    moveHere: 'Hierher verschieben',
    createNewFolder: 'Neuen Ordner erstellen',
    folderName: 'Ordnername',
    folderNameInvalidDots: "Ordnername darf '..' nicht enthalten (Sicherheitsrisiko)",
    folderNameInvalidStart: 'Ordnername darf nicht mit Pfadtrennzeichen beginnen',
    folderNameInvalidSlash: "Ordnername darf keine Schrägstriche ('/') enthalten",

    // Rename folder dialog
    renameFolderTitle: 'Ordner umbenennen',
    newFolderName: 'Neuer Ordnername',

    uploadingTo: 'Hochladen nach: {{path}}',
    flightAnalysisResults: 'Fluganalyse-Ergebnisse',
    rowsProcessed: 'Verarbeitete Zeilen',
    columnsProcessed: 'Verarbeitete Spalten',
    extractedMetadata: 'Extrahierte Metadaten',
    dropFilesHere: 'Dateien hier ablegen',
    dragAndDropFiles: 'Dateien hierher ziehen',
    orClickToBrowse: 'oder klicken zum Durchsuchen',
    allowedFilesInfo: 'Erlaubt: {{types}} (Max: {{maxFiles}} Dateien)',
    selectedFiles: 'Ausgewählte Dateien ({{count}})',
    analyze: 'Analysieren',
    remove: 'Entfernen',
    uploadingProgress: 'Hochladen... {{progress}}%',
    clearAll: 'Alle löschen',
    uploadSettings: 'Upload-Einstellungen',
    destination: 'Ziel:',
    destinationHelp:
      'Dateien werden in den aktuell angezeigten Ordner hochgeladen. Navigieren Sie vor dem Hochladen zu Ihrem Zielordner.',
    flightTypeRequired: 'Flugtyp *',
    loadingFlightTypes: 'Flugtypen werden geladen...',
    selectFlightType: 'Flugtyp auswählen',
    payloadRequired: 'Nutzlast *',
    loadingPayloads: 'Nutzlasten werden geladen...',
    selectPayload: 'Nutzlast auswählen',
    pilotRequired: 'Pilot *',
    loadingPilots: 'Piloten werden geladen...',
    selectPilot: 'Pilot auswählen',
    customer: 'Kunde',
    loadingCustomers: 'Kunden werden geladen...',
    selectCustomer: 'Kunde auswählen',
    addCustomer: 'Neuen Kunden hinzufügen',
    addNewCustomer: 'Neuen Kunden hinzufügen',
    customerName: 'Kundenname',
    customerAdded: 'Kunde erfolgreich hinzugefügt',
    failedToAddCustomer: 'Kunde konnte nicht hinzugefügt werden',
    project: 'Projekt',
    loadingProjects: 'Projekte werden geladen...',
    selectProject: 'Projekt auswählen',
    addProject: 'Neues Projekt hinzufügen',
    addNewProject: 'Neues Projekt hinzufügen',
    projectName: 'Projektname',
    projectAdded: 'Projekt erfolgreich hinzugefügt',
    failedToAddProject: 'Projekt konnte nicht hinzugefügt werden',
    addPayload: 'Neue Nutzlast hinzufügen',
    addNewPayload: 'Neue Nutzlast hinzufügen',
    payloadName: 'Nutzlastname',
    payloadWeight: 'Gewicht (kg)',
    payloadAdded: 'Nutzlast erfolgreich hinzugefügt',
    failedToAddPayload: 'Nutzlast konnte nicht hinzugefügt werden',
    airspaceObserver: 'Luftraumbeobachter',
    loadingAirspaceObservers: 'Luftraumbeobachter werden geladen...',
    selectAirspaceObserver: 'Luftraumbeobachter auswählen',
    payloadOperator: 'Nutzlastoperator',
    loadingPayloadOperators: 'Nutzlastoperatoren werden geladen...',
    selectPayloadOperator: 'Nutzlastoperator auswählen',
    flightTypePayloadRequired: 'Flugtyp und Nutzlast sind für CSV-Flugdatendateien erforderlich',
    flightTypePayloadPilotRequired:
      'Flugtyp, Nutzlast und Pilot sind für CSV-Flugdatendateien erforderlich',
    documentFilesInfo:
      'Dokumentdateien werden direkt hochgeladen - keine Flugmetadaten erforderlich',
    testModeLabel: 'Als Testdaten hochladen (Validierung umgehen)',
    filesToUpload: 'Hochzuladende Dateien:',
    uploadCount: '{{count}} Datei(en) hochladen',
    uploadSuccess: '{{count}} Datei(en) erfolgreich hochgeladen',
    fileAnalyzed: 'Datei erfolgreich analysiert',
    fileDeleted: 'Datei erfolgreich gelöscht',
    folderDeleted: 'Ordner erfolgreich gelöscht',
    folderCreated: 'Ordner erfolgreich erstellt',
    fileMoved: 'Datei erfolgreich verschoben',
    itemsMoved: '{{count}} Element(e) erfolgreich verschoben',
    itemsMovedPartial: '{{moved}} verschoben, {{failed}} fehlgeschlagen: {{names}}',
    folderMoved: 'Ordner erfolgreich verschoben',
    folderRenamed: 'Ordner erfolgreich umbenannt',
    downloadStarted: 'Download gestartet',
    includeUntaggedData: 'Nicht zugeordnete Daten einschließen',
    failedToLoadFiles: 'Dateien konnten nicht geladen werden',
    failedToUpload: 'Upload fehlgeschlagen',
    failedToAnalyze: 'Analyse fehlgeschlagen',
    failedToDownload: 'Download fehlgeschlagen',
    failedToDelete: 'Datei konnte nicht gelöscht werden',
    failedToDeleteFolder: 'Ordner konnte nicht gelöscht werden',
    failedToMove: 'Element konnte nicht verschoben werden',
    failedToCreateFolder: 'Ordner konnte nicht erstellt werden',
    failedToRenameFolder: 'Ordner konnte nicht umbenannt werden',
    failedToGenerateUrl: 'Download-URL konnte nicht generiert werden',
    cannotMoveToSameLocation: 'Element kann nicht an denselben Ort verschoben werden',
    maxFilesAllowed: 'Maximal {{count}} Dateien erlaubt',
    invalidFileTypes: 'Ungültige Dateitypen. Erlaubt: {{types}}',
    selectFilesToUpload: 'Bitte wählen Sie Dateien zum Hochladen aus',
    selectFlightTypeForCsv: 'Bitte wählen Sie einen Flugtyp für CSV-Dateien',
    selectPayloadForCsv: 'Bitte wählen Sie eine Nutzlast für CSV-Dateien',
    selectPilotForCsv: 'Bitte wählen Sie einen Piloten für CSV-Dateien',
    failedToLoadData:
      'Flugtypen, Nutzlasten und Piloten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    analysisCompleted: 'Analyse für {{fileName}} abgeschlossen',
    testData: 'Testdaten',
    unknownFile: 'Unbekannte Datei',

    // Duplicate file handling
    duplicateFilesSkipped: 'Doppelte Dateien übersprungen',
    duplicateFilesMessage:
      'Die folgenden {{count}} Datei(en) wurden übersprungen, da sie bereits vorhanden sind:',
  },

  // Flight Reports
  reports: {
    title: 'Flugberichte',
    backToFiles: '← Zurück zu Dateien',
    generateReport: 'Bericht erstellen',
    noReports: 'Noch keine Berichte',
    generateFirstReport: 'Erstellen Sie Ihren ersten Flugstundenbericht',

    // Loading/Error states
    failedToLoad: 'Berichte konnten nicht geladen werden',
    failedToGenerateUrl: 'Download-URL konnte nicht generiert werden',
    failedToDownload: 'Bericht konnte nicht heruntergeladen werden',
    failedToDelete: 'Bericht konnte nicht gelöscht werden',
    failedToLoadFilters: 'Filteroptionen konnten nicht geladen werden',

    // Actions
    confirmDelete: 'Sind Sie sicher, dass Sie "{{title}}" löschen möchten?',
    deleteSuccess: 'Bericht "{{title}}" erfolgreich gelöscht',
    deleteFailed: 'Bericht konnte nicht gelöscht werden',
    moreActions: 'Weitere Aktionen',
    download: 'Herunterladen',
    delete: 'Löschen',
    downloadStarted: 'Download gestartet für "{{title}}"',

    // Generation dialog
    generateReportTitle: 'Flugstundenbericht erstellen',
    reportTitle: 'Berichtstitel',
    titlePlaceholder: 'z.B. Q4 2025 Flugzusammenfassung',
    titleRequired: 'Berichtstitel ist erforderlich',
    datesRequired: 'Start- und Enddatum sind erforderlich',
    invalidDateRange: 'Startdatum muss vor dem Enddatum liegen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    selectDrones: 'Drohnen auswählen',
    allDrones: 'Alle Drohnen',
    selectPayloads: 'Nutzlasten auswählen',
    allPayloads: 'Alle Nutzlasten',
    selectPilots: 'Piloten auswählen',
    allPilots: 'Alle Piloten',
    leaveEmptyForAll: 'Leer lassen, um alle einzuschließen',
    includeIncidents: 'Vorfälle/Unfälle',
    generate: 'Bericht erstellen',
    generateSuccess: 'Bericht erfolgreich erstellt',
    generateFailed: 'Bericht konnte nicht erstellt werden',

    // Content type selection
    includeInReport: 'Im Bericht einschließen',
    includeFlightHours: 'Flugstunden',
    includeMaintenanceData: 'Wartungsdaten',
    selectAtLeastOne: 'Wählen Sie mindestens einen Inhaltstyp für den Bericht aus',

    // Maintenance filters
    maintenanceTypes: 'Wartungstypen',
    allMaintenanceTypes: 'Alle Wartungstypen',
    maintenanceTypesHelper: 'Leer lassen, um alle Wartungstypen einzuschließen',
  },

  healthPanel: {
    title: 'Gesundheitspanel',
    selectDrone: 'Wählen Sie eine Drohne, um das Gesundheitspanel anzuzeigen',
    systemHealth: 'Systemgesundheit',
    lastUpdated: 'Zuletzt aktualisiert',
    noData: 'Keine Gesundheitsdaten verfügbar',

    // Panel titles
    engineStartup: 'Motorstart',
    performance: 'Leistung',
    cooling: 'Kühlung',
    batteries: 'Batterien',
    fuelSystem: 'Kraftstoffsystem',
    liftSystem: 'Hebesystem',

    // Panel info content
    performanceInfo:
      'Normalbereich: 80-100%. Trend berechnet durch lineare Regression auf historischen Flugdaten.',
    coolingInfo:
      'Normalbereich: 0-125°C. Trend berechnet durch lineare Regression auf historischen Flugdaten.',

    // Analysis displays
    latest: 'Aktueller {{title}}:',
    trend: 'Trend:',
    forecast: 'Prognose:',
    forecastBy: 'bis {{date}}',
    rSquared: '(R² = {{value}})',
    insufficientData:
      'Unzureichende Daten für Trendanalyse (mindestens 3 Datenpunkte erforderlich)',

    // Click-a-point formula popup
    pointFormula: 'Formel',
    pointValues: 'Werte dieses Flugs',
    pointNoSources: 'Für diesen Flug wurden keine Quellwerte gespeichert.',
    pointNoFormula: 'Für diese Kennzahl sind keine Formeldetails verfügbar.',

    // Status labels
    statusNormal: 'NORMAL',
    statusWarning: 'WARNUNG',
    statusUnknown: 'UNBEKANNT',
    outOfBandFlights:
      '{{count}} von {{total}} dargestellten Flügen außerhalb des zulässigen Bereichs',

    // TUWT display
    warningTime: 'Warnzeit',
    errorTime: 'Fehlerzeit',
    ofTotal: '({{percentage}}% von gesamt)',
    totalMonitoringTime: 'Gesamtüberwachungszeit:',

    // Trend labels
    trendImproving: 'VERBESSERND',
    trendWorsening: 'VERSCHLECHTERND',
    trendStable: 'STABIL',
    trendLabel: 'Trend: {{trend}}',
  },

  admin: {
    title: 'Admin-Werkzeuge',
    droneManagement: 'Drohnenverwaltung',
    userManagement: 'Benutzerverwaltung',
    organizationManagement: 'Organisationsverwaltung',
    announcements: 'Ankündigungen',
    inviteUser: 'Benutzer einladen',
    createDrone: 'Drohne erstellen',
    createOrganization: 'Organisation erstellen',
    createAnnouncement: 'Ankündigung erstellen',
    users: 'Benutzer',
    userName: 'Name',
    userEmail: 'E-Mail',
    userRole: 'Rolle',
    userOrganization: 'Organisation',
    userStatus: 'Status',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    assignOrganization: 'Organisation zuweisen',
    roleAdmin: 'Administrator',
    roleUser: 'Benutzer',
    roleMaintainer: 'Wartungspersonal',
    drones: 'Drohnen',
    droneSerial: 'Seriennummer',
    droneOrganization: 'Organisation',
    editDrone: 'Drohne bearbeiten',
    deleteDrone: 'Drohne löschen',
    organizations: 'Organisationen',
    orgName: 'Name',
    orgSlug: 'Slug',
    editOrganization: 'Organisation bearbeiten',
    deleteOrganization: 'Organisation löschen',
    announcementTitle: 'Titel',
    announcementContent: 'Inhalt',
    announcementPriority: 'Priorität',
    priorityLow: 'Niedrig',
    priorityMedium: 'Mittel',
    priorityHigh: 'Hoch',
    editAnnouncement: 'Ankündigung bearbeiten',
    deleteAnnouncement: 'Ankündigung löschen',
  },

  inviteDialog: {
    title: 'Benutzer einladen',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'E-Mail-Adresse eingeben',
    roleLabel: 'Rolle',
    sendInvitation: 'Einladung senden',
    sending: 'Wird gesendet...',
    successMessage: 'Einladung erfolgreich an {{email}} gesendet',
    errorMessage: 'Fehler beim Senden der Einladung',
  },

  inbox: {
    title: 'Posteingang',
    noMessages: 'Keine Nachrichten',
    markAsRead: 'Als gelesen markieren',
    markAllAsRead: 'Alle als gelesen markieren',
    delete: 'Löschen',
    failedToLoad: 'Ankündigungen konnten nicht geladen werden',
    failedToMarkRead: 'Ankündigung konnte nicht als gelesen markiert werden',
    failedToDownloadAttachment: 'Anhang konnte nicht heruntergeladen werden',
  },

  documents: {
    title: 'Dokumente',
    backToFiles: '← Zurück zu Dateien',
    uploadDocument: 'Dokument hochladen',
    noDocuments: 'Keine Dokumente gefunden',
    uploadFirstDocument: 'Laden Sie Ihr erstes Dokument hoch, um zu beginnen',
    moreActions: 'Weitere Aktionen',
    download: 'Herunterladen',
    delete: 'Löschen',
    validUntil: 'Gültig bis:',

    typeInsurance: 'Versicherung',
    typePermit: 'Genehmigung',
    typeOther: 'Sonstiges',

    selectFile: 'Datei auswählen',
    titleLabel: 'Titel',
    descriptionLabel: 'Beschreibung',
    documentType: 'Dokumenttyp',
    validityStartDate: 'Gültigkeitsbeginn (Optional)',
    validityEndDate: 'Gültigkeitsende (Optional)',

    titleRequired: 'Titel ist erforderlich',
    pleaseSelectFile: 'Bitte wählen Sie eine Datei aus',
    startDateBeforeEnd: 'Startdatum muss vor dem Enddatum liegen',

    uploadSuccess: 'Dokument erfolgreich hochgeladen',
    uploadFailed: 'Hochladen fehlgeschlagen',
    downloadedDocument: '{{title}} heruntergeladen',
    failedToGenerateUrl: 'Download-URL konnte nicht generiert werden',
    failedToDownload: 'Dokument konnte nicht heruntergeladen werden',
    confirmDelete: 'Sind Sie sicher, dass Sie "{{title}}" löschen möchten?',
    deleteSuccess: 'Dokument {{title}} erfolgreich gelöscht',
    deleteFailed: 'Löschen fehlgeschlagen',
    failedToDelete: 'Dokument konnte nicht gelöscht werden',
    failedToLoad: 'Dokumente konnten nicht geladen werden',
    failedToUpload: 'Dokument konnte nicht hochgeladen werden',
  },

  sessionTimeout: {
    title: 'Sitzungszeitüberschreitung',
    message: 'Ihre Sitzung läuft wegen Inaktivität bald ab.',
    stayLoggedIn: 'Angemeldet bleiben',
    logout: 'Abmelden',
    expiresIn: 'Sitzung läuft in {{seconds}} Sekunden ab',
  },

  chat: {
    title: 'Chat',
    placeholder: 'Nachricht eingeben...',
    send: 'Senden',
    minimize: 'Minimieren',
    close: 'Chat schließen',
    failedToLoadPageImage: 'Seitenbild konnte nicht geladen werden',
  },

  errors: {
    generic: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    networkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.',
    unauthorized: 'Sie sind nicht berechtigt, diese Aktion durchzuführen.',
    notFound: 'Die angeforderte Ressource wurde nicht gefunden.',
    serverError: 'Serverfehler. Bitte versuchen Sie es später erneut.',
    validationError: 'Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.',
    sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    failedToLoad: 'Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.',
    failedToSave: 'Fehler beim Speichern der Änderungen. Bitte versuchen Sie es erneut.',
    failedToDelete: 'Fehler beim Löschen. Bitte versuchen Sie es erneut.',
  },

  // Admin Tools Page
  adminToolsPage: {
    // Page header
    title: 'Admin-Werkzeuge',
    subtitle: 'Administrator-Tools und Dienstprogramme',
    backToDashboard: 'Zurück zum Dashboard',

    // Access denied
    accessDenied: 'Zugriff verweigert',
    adminOnlyMessage: 'Diese Seite ist nur für Administratoren zugänglich.',
    returnToDashboard: 'Zum Dashboard zurückkehren',

    // Common labels
    xerAdminOnly: 'Nur XER-Admin',
    users: 'Benutzer',
    close: 'Schließen',
    cancel: 'Abbrechen',
    assign: 'Zuweisen',

    // Roles
    roles: {
      admin: 'Admin',
      adminDesc: 'Vollzugriff auf das System',
      pilot: 'Pilot',
      pilotDesc: 'Flugbetrieb',
      maintenance: 'Wartung',
      maintenanceDesc: 'Wartungsoperationen',
      airspaceObserver: 'Luftraumbeobachter',
      airspaceObserverDesc: 'Nur Überwachung',
      noRolesAssigned: 'Keine Rollen zugewiesen',
    },

    // Metadata Extraction Card
    metadataExtraction: {
      title: 'Metadaten-Extraktion erneut ausführen',
      description:
        'CSV-Dateien erneut verarbeiten, um aktuelle Metadaten mit dem neuesten XER-Metadaten-Extraktor zu extrahieren. Dies aktualisiert die Flugdaten in der Datenbank.',
      processingScope: 'Verarbeitungsumfang:',
      xerOnly: 'Nur XER Technologies',
      allOrganizations: 'ALLE Organisationen',
      extractingFiles: 'Extrahiere Metadaten aus CSV-Dateien... ({{current}}/{{total}} Dateien)',
      startedBy: 'Gestartet von: {{user}} um {{time}}',
      processingNote: 'Dieser Vorgang kann bei großen Dateisammlungen mehrere Minuten dauern.',
      processingInProgress: 'Verarbeitung läuft...',
      successMessage: 'Erfolgreich {{processed}}/{{total}} CSV-Dateien verarbeitet',
      failedMessage: '{{message}}',
      filesFailed: '{{count}} Dateien konnten nicht verarbeitet werden',
      completedIn: 'Abgeschlossen in {{seconds}} Sekunden',
      s3Modified: '{{count}} S3-Dateien mit erweiterten CSV-Daten geändert',
      detailedLog: 'Detailliertes Protokoll:',
      download: 'Herunterladen',
      failedFiles: 'Fehlgeschlagene Dateien:',
      andMore: '... und {{count}} weitere',
      jobRunning: 'Auftrag läuft...',
      processing: 'Verarbeitung...',
      startGlobalReExtraction: 'Globale Extraktion starten',
      startReExtraction: 'Extraktion starten',
    },

    // Add Drone Card
    addDrone: {
      title: 'Neue Drohne zur Datenbank hinzufügen',
      description:
        'Eine neue Drohnen-Seriennummer zur Datenbank hinzufügen. Dies ermöglicht das Hochladen von Flugdaten für diese Drohne. Drohnen werden automatisch der XER Technologies Organisation zugewiesen.',
      buttonLabel: 'Neue Drohne hinzufügen',
      dialogTitle: 'Neue Drohne zur Datenbank hinzufügen',
      serialNumber: 'Seriennummer *',
      serialNumberPlaceholder: 'Drohnen-Seriennummer eingeben',
      model: 'Modell (Optional)',
      modelPlaceholder: 'Drohnenmodell eingeben',
      commissioningDate: 'Inbetriebnahmedatum (Optional)',
      serialRequired: 'Seriennummer ist erforderlich',
      notes: {
        uniqueSerial: 'Seriennummer ist erforderlich und muss eindeutig sein',
        assignedToXer: 'Drohne wird der XER Technologies Organisation zugewiesen',
        activeByDefault: "Status wird standardmäßig auf 'aktiv' gesetzt",
      },
      adding: 'Hinzufügen...',
      addDrone: 'Drohne hinzufügen',
    },

    // User Management Card
    userManagement: {
      title: 'Benutzerverwaltung',
      description:
        'Alle Benutzer in Ihrer Organisation und ihre zugewiesenen Rollen anzeigen. Benutzerzugriff und Berechtigungen auf der Plattform überwachen.',
      viewUsers: 'Benutzer anzeigen',
      inviteUser: 'Benutzer einladen',
      tableHeaders: {
        name: 'Name',
        email: 'E-Mail',
        roles: 'Rollen',
        joined: 'Beigetreten',
        actions: 'Aktionen',
      },
      noUsersFound: 'Keine Benutzer in dieser Organisation gefunden.',
    },

    // Organization Management Card
    orgManagement: {
      title: 'Organisationsverwaltung',
      description:
        'Alle Organisationen im System anzeigen und verwalten. Organisationseinstellungen und Zugriff auf der Plattform überwachen.',
      viewOrganizations: 'Organisationen anzeigen',
      createNewOrg: 'Neue Organisation erstellen',
      unassignedUsers: 'Nicht zugewiesene Benutzer ({{count}})',
      unassignedUsersWarning:
        'Diese Benutzer haben sich registriert, sind aber noch keiner Organisation zugewiesen.',
      tableHeaders: {
        registered: 'Registriert',
        assignToOrg: 'Organisation zuweisen',
        assignRoles: 'Rollen zuweisen',
        action: 'Aktion',
        orgName: 'Organisationsname',
      },
      selectOrganization: 'Organisation auswählen',
      noOrgsFound: 'Keine Organisationen im System gefunden.',
      createOrgDialog: {
        title: 'Neue Organisation erstellen',
        orgName: 'Organisationsname *',
        orgNamePlaceholder: 'Organisationsnamen eingeben',
        slug: 'Slug: {{slug}}',
        creating: 'Erstellen...',
        createOrg: 'Organisation erstellen',
      },
    },

    // Drone Assignments Card
    droneAssignments: {
      title: 'Drohnenzuweisungen',
      description:
        'Drohnen-Organisationszuweisungen verwalten. Drohnen bei Bedarf zwischen Organisationen für betriebliche Flexibilität neu zuweisen.',
      manageAssignments: 'Zuweisungen verwalten',
      dialogTitle: 'Drohnen-Organisationszuweisungen',
      tableHeaders: {
        serialNumber: 'Seriennummer',
        currentOrg: 'Aktuelle Organisation',
        status: 'Status',
        ownershipType: 'Eigentumsart',
        leaseEndDate: 'Leasingende',
        actions: 'Aktionen',
      },
      noOrgAssigned: 'Keine Organisation zugewiesen',
      noDronesFound: 'Keine Drohnen im System gefunden.',
      noOwnership: 'Nicht festgelegt',
    },

    // Maintenance Documents Card
    maintenanceDocs: {
      title: 'Wartungsdokumente',
      description:
        'Wartungsdokumentation für den KI-Agenten verwalten. Handbücher, Verfahren, Werkzeugspezifikationen und Diagramme für intelligente Wartungsunterstützung hochladen.',
      manageDocuments: 'Dokumente verwalten',
      dialogTitle: 'Wartungsdokumente-Verwaltung',
      uploadSection: 'Neues Dokument hochladen',
      selectPdfFile: 'PDF-Datei auswählen',
      selectedFile: 'Ausgewählt: {{name}} ({{size}} MB)',
      documentTitle: 'Dokumenttitel *',
      documentType: 'Dokumenttyp *',
      docTypes: {
        manual: 'Handbuch',
        procedure: 'Verfahren',
        toolSpec: 'Werkzeugspezifikation',
        diagram: 'Diagramm',
        safety: 'Sicherheitsdokument',
      },
      version: 'Version (Optional)',
      versionPlaceholder: 'v2.1, Rev 3, etc.',
      droneModel: 'Drohnenmodell (Optional)',
      droneModelPlaceholder: 'DJI Mavic 3, etc.',
      manufacturer: 'Hersteller (Optional)',
      manufacturerPlaceholder: 'DJI, Xer Technologies, etc.',
      uploading: 'Hochladen...',
      uploadDocument: 'Dokument hochladen',
      uploadedDocuments: 'Hochgeladene Dokumente',
      noDocsYet: 'Noch keine Dokumente hochgeladen. Laden Sie Ihr erstes Dokument oben hoch.',
      tableHeaders: {
        title: 'Titel',
        type: 'Typ',
        size: 'Größe',
        status: 'Status',
        uploaded: 'Hochgeladen',
        actions: 'Aktionen',
      },
      processed: 'Verarbeitet ({{chunks}} Chunks)',
      notProcessed: 'Nicht verarbeitet',
      reprocessDoc: 'Dokument erneut verarbeiten',
      processForAI: 'Dokument für KI-Agent verarbeiten',
      deleteDocument: 'Dokument löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie dieses Dokument löschen möchten?\n\nKey: {{key}}',
    },

    // Tender Emails Card
    tenderEmails: {
      title: 'Ausschreibungs-E-Mails',
      description:
        'E-Mails anzeigen, die an Trent (den Ausschreibungs-Agenten) weitergeleitet wurden, und deren KI-Bewertungen. Ausschreibungspipeline überwachen und fehlgeschlagene E-Mails erneut verarbeiten.',
      viewEmails: 'Ausschreibungs-E-Mails anzeigen',
      dialogTitle: 'Ausschreibungs-E-Mail-Bewertungen',
      filterStatus: 'Status',
      allStatuses: 'Alle',
      refresh: 'Aktualisieren',
      noEmails: 'Keine Ausschreibungs-E-Mails gefunden.',
      tableHeaders: {
        subject: 'Betreff',
        from: 'Von',
        status: 'Status',
        evaluation: 'Bewertung',
        confidence: 'Konfidenz',
        date: 'Empfangen',
        actions: 'Aktionen',
      },
      reprocess: 'E-Mail erneut verarbeiten',
      summary: 'Zusammenfassung',
      client: 'Kunde',
      deadline: 'Frist',
      budget: 'Budget',
      keyFactors: 'Schlüsselfaktoren',
      reasoning: 'Analyse',
      replySent: 'Antwort gesendet',
      processedAt: 'Verarbeitet',
      scrapedLinks: 'Gescrapte Links',
      attachments: 'Anhänge',
      individualTenders: 'Einzelne Ausschreibungen',
      tenderTitle: 'Ausschreibung',
      pages: 'Seiten',
    },

    // Announcements Card
    announcements: {
      title: 'Ankündigungen',
      description:
        'Plattformweite Ankündigungen an Benutzer und Organisationen senden. Zustellung und Lesestatus für alle gesendeten Nachrichten verfolgen.',
      manageAnnouncements: 'Ankündigungen verwalten',
      dialogTitle: 'Ankündigungsverwaltung',
      sendNew: 'Neue Ankündigung senden',
      announcementTitle: 'Titel *',
      messageBody: 'Nachrichtentext *',
      sendTo: 'Senden an *',
      targetTypes: {
        allUsers: 'Alle Plattformbenutzer',
        specificOrgs: 'Bestimmte Organisationen',
        specificUsers: 'Bestimmte Benutzer',
      },
      selectOrganizations: 'Organisationen auswählen *',
      selectUsers: 'Benutzer auswählen *',
      attachFiles: 'Dateien anhängen (Optional)',
      sendEmailNotification: 'Auch E-Mail-Benachrichtigung senden',
      sending: 'Senden...',
      sendAnnouncement: 'Ankündigung senden',
      sentSuccess: 'Ankündigung an {{count}} Benutzer gesendet!',
      sentAnnouncements: 'Gesendete Ankündigungen ({{count}})',
      tableHeaders: {
        title: 'Titel',
        created: 'Erstellt',
        recipients: 'Empfänger',
        readUnread: 'Gelesen / Ungelesen',
      },
      by: 'von {{name}}',
      read: '{{count}} gelesen',
      unread: '{{count}} ungelesen',
      noAnnouncementsYet: 'Noch keine Ankündigungen gesendet.',
    },

    // Maintenance Recalculate Card
    maintenanceRecalculate: {
      title: 'Wartungszähler neu berechnen',
      description:
        'Alle Wartungszähler für eine Drohne von Grund auf neu berechnen. Baut die Wartungshistorie neu auf und behebt Dateninkonsistenzen.',
      buttonLabel: 'Zähler neu berechnen',
      selectDrone: 'Drohne auswählen',
      recalculate: 'Neu berechnen',
      recalculating: 'Wird neu berechnet...',
      infoText: 'Dies berechnet alle Wartungszähler von Grund auf neu. Das System wird:',
      infoBullet1:
        'Wartungshistorie aus allen abgeschlossenen und qualitätsgeprüften Einträgen neu aufbauen',
      infoBullet2:
        'Alle Flug- und Motorstundenzähler basierend auf durchgeführter Wartung zurücksetzen',
      infoBullet3: 'Dateninkonsistenzen beheben',
      resultComplete: 'Neuberechnung abgeschlossen',
      resultSummary:
        '{{processed}} Wartungseinträge verarbeitet \u2022 {{reset}} Zähler aktualisiert \u2022 {{unchanged}} unverändert',
      viewDetails: 'Details anzeigen',
      hideDetails: 'Details ausblenden',
      totalFlightHours: 'Gesamtflugstunden',
      totalEngineHours: 'Gesamtmotorstunden',
      countersBreakdown: 'Aufschlüsselung der Wartungszähler',
      tableCounter: 'Zähler',
      tableLastMaintenance: 'Letzte Wartung',
      tableFlightsSince: 'Flüge seitdem',
      tableTotalHours: 'Gesamtstunden',
      tableRemaining: 'Verbleibend',
      flightHoursLabel: 'Flugstunden',
      engineHoursLabel: 'Motorstunden',
      byPerformer: 'von {{name}}',
      neverMaintained: 'Nie gewartet',
      noFlights: 'Keine Flüge',
    },

    // Invite User Dialog
    inviteUser: {
      dialogTitle: 'Benutzer zur Organisation einladen',
      emailAddress: 'E-Mail-Adresse *',
      emailPlaceholder: 'benutzer@beispiel.de',
      emailHelperText: 'Der Benutzer erhält einen Einladungslink per E-Mail',
      selectRoles: 'Rollen auswählen *',
      selectRolesHelper: 'Wählen Sie eine oder mehrere Rollen für diesen Benutzer',
      validation: {
        emailRequired: 'E-Mail ist erforderlich',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        selectRole: 'Bitte wählen Sie mindestens eine Rolle',
      },
      invitationNote:
        'Der Einladungslink läuft nach 24 Stunden ab. Der Benutzer wird automatisch Ihrer Organisation zugewiesen, wenn er die Einladung annimmt.',
      cancel: 'Abbrechen',
      sending: 'Senden...',
      sendInvitation: 'Einladung senden',
      failedToSend: 'Einladung konnte nicht gesendet werden',
    },
  },

  // User Guide (EN placeholder — pending translation)
  guide: {
    title: 'User Guide',
    subtitle: 'Workflow guides for common tasks',
    backToDashboard: 'Back to Dashboard',
    headerTooltip: 'User Guide',
    common: {
      tip: 'Tip',
      important: 'Important',
    },
    sections: {
      uploadFlightData: 'Uploading & Analyzing Flight Data',
      shareFlights: "Sharing a Drone's Flights",
      maintenanceRecords: 'Maintenance Records',
      maintenanceRecordsCreating: 'Creating a Record',
      maintenanceRecordsQuality: 'Quality Checks',
      maintenanceRecordsSchedules: 'Reading Schedules',
      healthPanel: 'Reading the Health Panel',
      healthPanelAvgr: 'Understanding AVGR',
      healthPanelAvgt: 'Understanding AVGT',
      healthPanelTuwt: 'Understanding TUWT',
      healthPanelAction: 'When to Take Action',
      droneNotes: 'Drone Notes & Timeline',
      droneNotesCreating: 'Creating Notes',
      droneNotesFilters: 'Using Filters',
      droneNotesTimeline: 'Timeline Interaction',
      llmChat: 'AI Chat Assistant',
      llmChatSql: 'SQL Query Agent',
      llmChatMaintenance: 'Maintenance Agent',
      llmChatTips: 'Tips & Limits',
      inviteUsers: 'Inviting Users & Assigning Roles',
    },
    uploadFlightData: {
      intro:
        'Flight data files (CSV) require metadata before upload. This workflow walks you through uploading files and optionally analyzing them first.',
      steps: {
        s1: 'Navigieren Sie zum Dateien-Tab.',
        s2: 'Open the folder where you want to upload files.',
        s3: 'Click "Upload Files" to expand the upload zone.',
        s4: 'Drag and drop files into the upload zone, or click to browse your computer.',
        s5: 'For CSV flight data files, fill in the required metadata: flight type, payload, and pilot. These fields are mandatory for flight data.',
        s6: 'Optionally, click "Analyze" on a file to preview extracted metadata (rows, columns, detected values) before uploading.',
        s7: 'Click the upload button to upload all selected files.',
      },
      tipDocuments:
        'Document files (PDF, images) do not require flight metadata — they are uploaded directly.',
      tipAnalyze:
        'Use the "Analyze" button to validate a file before uploading. This lets you confirm the file has the expected data without committing to an upload.',
      tipPlotting:
        'To visualize and explore uploaded flight data in detail, use the "Plot Flight Data" button in the dashboard header. It opens the plotting tool where you can browse your folder structure, select a CSV file, and chart individual parameters from the flight.',
    },
    shareFlights: {
      intro:
        'Your organization can share every flight of one drone with XER Technologies in one action, for example so XER can support the aircraft. Each shared flight comes with its CSV log file and the .bin logs linked to it.',
      steps: {
        s1: 'Go to the "{{files}}" tab, open "{{sharedWithMe}}" and pick the "{{flights}}" tab.',
        s2: 'Click "{{openBulk}}".',
        s3: '{{drone}}: pick the drone\'s serial number (for example 105). {{organization}}: XER Technologies. Leave "{{fromDate}}" empty: it uses the drone\'s recorded handover date. {{access}}: "{{read}}".',
        s4: 'Click "{{share}}". A message confirms how many flights were shared.',
      },
      whatTheySee:
        'The other organization then finds these flights under "{{sharedWithMe}}", "{{flights}}", "{{inbound}}", and can open and download each flight\'s CSV log file. "{{read}}" lets them see and download the flights and nothing more: they cannot change or delete them. Shared flights do not count toward the other organization\'s own fleet totals. To stop sharing a flight, use "{{unshare}}" on it under "{{outbound}}".',
      whereTheyAppear:
        'Besides "{{sharedWithMe}}", shared flights appear on the drone\'s own pages (its profile timeline, flight list and Health panel), each marked as shared by your organization, and the drone\'s counters there say how many shared flights they include.',
      warningAdmins: 'Only organization admins see the "{{openBulk}}" button.',
      tipReshare:
        'Sharing covers the flights uploaded so far, not later ones. After you upload new flights for the drone, repeat these steps and click "{{share}}" again: only the new flights are added, and flights that are already shared are skipped.',
      tipBinLogs:
        '"{{openBulk}}" shares the drone\'s CSV flight logs, and every .bin log linked to one of those flights. When you upload a .bin log, the Dashboard looks for a flight of the same day with a matching start time and asks whether they are the same flight: answer "{{sameFlight}}" to link them. For a .bin log uploaded earlier, right-click it in the "{{files}}" tab and choose "{{linkFlight}}". A linked log follows the flight: whoever the flight is shared with can open it, and revoking the flight share withdraws it. Sharing the folder that holds the .bin logs ("{{shareFolder}}", XER Technologies under "{{folderOrganization}}", "{{folderShare}}") still works as well.',
      tipHandoverDate:
        'If the dialog says no handover date is recorded for the drone, enter the date your organization took the drone over in "{{fromDate}}" and click "{{share}}" again. Flights before that date are XER\'s own acceptance flights and are not shared.',
    },
    maintenanceRecords: {
      intro:
        'Maintenance records track work performed on a drone. Creating a record and having it quality-checked are separate steps done by different users.',
      layoutDescription:
        'The Maintenance tab has two panels: Upcoming Maintenance shows what is due or overdue based on hour intervals, and Maintenance History shows completed records.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Maintenance tab.',
          s2: 'Click "Add Maintenance" to open the maintenance record form.',
          s3: 'Select one or more maintenance types. You can also create a new type on-the-fly if the one you need does not exist.',
          s4: 'Fill in the work description explaining what was done.',
          s5: 'Select who performed the maintenance.',
          s6: 'Set the start and end dates for when the work was carried out.',
          s7: 'Attach any evidence files (photos, reports) during creation.',
          s8: 'Save the record.',
        },
      },
      warningAttachments:
        'File attachments can only be added when creating the record. You cannot attach files after the record has been saved.',
      quality: {
        description:
          'After a maintenance record is created, a different user must quality-check it. The person who created the record cannot approve their own work.',
        warningDifferentUser:
          'Quality checks require a different user than the one who created the record. This is enforced by the system.',
      },
      schedules: {
        description:
          'Upcoming maintenance is based on hours-based intervals configured for each maintenance type. The panel shows how many hours remain until maintenance is due, or how many hours overdue it is. Red indicators mean the maintenance is overdue and should be performed as soon as possible.',
      },
      tipNewTypes:
        'You can create new maintenance types on-the-fly from the maintenance record form. This is useful when a new type of work is performed for the first time.',
    },
    healthPanel: {
      intro:
        'The Health Panel provides automated analysis of drone sensor data. It uses three different metric types to give you a complete picture of system health.',
      openingSteps: {
        s1: 'Select a drone from the fleet overview.',
        s2: 'Navigate to the Health Panel tab.',
        s3: 'Review the metric cards organized by system (Performance, Cooling, Batteries, etc.).',
      },
      avgr: {
        title: 'AVGR (Average Reading)',
        description:
          'AVGR shows a single value: the latest average reading for a sensor. It includes a status indicator — NORMAL (within expected range) or WARNING (outside expected range). Use this to quickly check if a sensor is currently within acceptable limits.',
      },
      avgt: {
        title: 'AVGT (Average Trend)',
        description:
          'AVGT shows a historical trend line calculated using linear regression. It includes a trend direction (IMPROVING, STABLE, or WORSENING), a forecast value for a future date, and an R² confidence score. Higher R² means the forecast is more reliable.',
        warningRSquared:
          'A low R² value (below 0.5) means the data has high variability and the forecast may not be reliable. Do not make critical decisions based on low-confidence forecasts alone.',
      },
      tuwt: {
        title: 'TUWT (Time Under Warning Threshold)',
        description:
          'TUWT shows how much time a sensor spent in warning or error state, expressed as a percentage of total monitoring time. Warning time means the sensor was outside normal range. Error time means the sensor was in a critical state.',
      },
      action: {
        description:
          'Consider taking action when: TUWT error percentage is high, AVGT shows a worsening trend with high R², or AVGR shows WARNING status consistently. Combine multiple indicators rather than relying on any single metric.',
      },
      tipDataPoints:
        'Trend analysis requires at least 3 data points. With fewer data points, the Health Panel will show the message "Insufficient data for trend analysis" instead of a forecast.',
    },
    droneNotes: {
      intro:
        'Notes let you document observations, customer feedback, and alerts for a drone. The timeline view connects notes to flight data visually.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Profile tab.',
          s2: 'Click "Create Note" (or the + button) in the Notes section.',
          s3: 'Enter a subject line for the note.',
          s4: 'Select the note type: General, Customer Feedback, or Alert.',
          s5: 'Set the priority: Information or Critical.',
          s6: 'Write the note content.',
          s7: 'Save the note.',
        },
      },
      filters: {
        description:
          'Use the filter controls to narrow down the notes list. You can filter by type (General, Customer Feedback, Alert), priority (Information, Critical), and whether resolved notes are included.',
      },
      timeline: {
        description:
          'The timeline at the top of the Profile tab shows a Gantt chart of flight data. Clicking a flight bar in the timeline scrolls down to and highlights the corresponding note below. This helps you connect specific flights to related observations.',
        tipDateRange:
          'The date range slider filters the notes list but does not affect the timeline view. The timeline always shows all available data.',
      },
    },
    llmChat: {
      intro:
        'The platform includes an AI chat assistant accessible via the floating button in the bottom-right corner of the dashboard. You choose an agent, then ask questions in natural language.',
      steps: {
        s1: 'Click the chat bubble in the bottom-right corner of the screen.',
        s2: 'Select an agent: SQL Query Agent for data questions, or Maintenance Agent for technical documentation.',
        s3: 'Type your question or click one of the example queries shown.',
        s4: 'Review the response. For SQL queries, you can expand "View SQL" to see the exact query that was executed.',
      },
      sql: {
        title: 'SQL Query Agent',
        description:
          'Ask questions about your fleet data in plain language. The agent converts your question into a SQL query, runs it against the database, and returns the results in readable form. You only see data from your own organization — this is enforced automatically.',
        examples:
          'Example questions: "How many flights under 10 minutes for drone 102?", "What is the total flight time this month?", "Show me drones that need maintenance", "How many unresolved notes are there?"',
      },
      maintenance: {
        title: 'Maintenance Agent',
        description:
          'Ask questions about maintenance procedures, safety protocols, and technical specifications. The agent searches uploaded maintenance documentation (manuals, procedures, tool specs) and synthesizes an answer with source citations. Answers reference specific document sections and page numbers.',
        examples:
          'Example questions: "How do I replace the propellers?", "What are the safety protocols for battery maintenance?", "Troubleshooting steps for motor failure", "What tools do I need for routine inspection?"',
      },
      tips: {
        rateLimit:
          'You are limited to 20 queries per hour. The limit resets automatically. If you reach it, wait and try again later.',
        feedback:
          'Use the thumbs up/down buttons on responses to provide feedback. This helps improve the quality of answers over time. Thumbs down lets you add an optional comment explaining what was wrong.',
        privacy:
          'All queries are scoped to your organization. The SQL agent can only read data — it cannot modify, delete, or create anything in the database.',
        session:
          'The chat remembers your conversation within a session. Click the refresh icon in the chat header to start a new session and switch agents.',
      },
    },
    inviteUsers: {
      intro:
        'When you invite a user, they receive an email link. Once they accept and create their account, they are automatically assigned to your organization with the roles you selected.',
      steps: {
        s1: 'Navigate to Admin Tools.',
        s2: 'In the User Management section, click "Invite User".',
        s3: "Enter the user's email address and select one or more roles.",
        s4: 'Click "Send Invitation". The user receives an email with a link to create their account.',
        s5: 'When the user clicks the link and creates their password, they are automatically assigned to your organization with the selected roles.',
        s6: 'The user can now sign in and access the system immediately.',
      },
      warningExpiry:
        'Invitation links expire in 24 hours. If the link expires, you need to send a new invitation.',
      warningUnassigned:
        'The "Unassigned Users" list in Organization Management shows users who registered on their own (without an invitation). These users must be manually assigned to an organization by an admin before they can access the system.',
    },
  },

  inventory: {
    title: 'Inventar',
    locations: 'Standorte',
    items: 'Gegenstände',
    allItems: 'Alle Gegenstände',
    addLocation: 'Standort hinzufügen',
    addItem: 'Gegenstand hinzufügen',
    editLocation: 'Standort bearbeiten',
    editItem: 'Gegenstand bearbeiten',
    deleteLocation: 'Standort löschen',
    deleteItem: 'Gegenstand löschen',
    confirmDeleteLocation:
      'Möchten Sie diesen Standort wirklich löschen? Alle untergeordneten Standorte werden ebenfalls gelöscht. Gegenstände in gelöschten Standorten werden nicht zugeordnet.',
    confirmDeleteItem: 'Möchten Sie diesen Gegenstand wirklich löschen?',
    name: 'Name',
    locationType: 'Typ',
    parentLocation: 'Übergeordneter Standort',
    notes: 'Notizen',
    quantity: 'Menge',
    category: 'Kategorie',
    location: 'Standort',
    search: 'Gegenstände suchen...',
    noLocations: 'Noch keine Standorte. Fügen Sie Ihren ersten Standort hinzu.',
    noItems: 'Keine Gegenstände gefunden.',
    noItemsInLocation: 'Keine Gegenstände an diesem Standort.',
    sortOrder: 'Sortierreihenfolge',
    locationTypes: {
      area: 'Bereich',
      shelf: 'Regal',
      level: 'Ebene',
      box: 'Box',
      pelicase: 'Pelicase',
      bag: 'Tasche',
      section: 'Abschnitt',
      bucket: 'Eimer',
      container: 'Container',
    },
    actions: 'Aktionen',
    searchLocations: 'Standorte suchen...',
    locationPath: 'Standortpfad anzeigen',
    backTo: 'Zurück zu {{name}}',
    rootLevel: 'Stammverzeichnis',
    noSelection: 'Keine Auswahl',
  },

  operationsEquipment: {
    title: 'Betriebsausrüstung',
    add: 'Ausrüstung hinzufügen',
    addTitle: 'Ausrüstung hinzufügen',
    edit: 'Bearbeiten',
    editTitle: 'Ausrüstung bearbeiten',
    delete: 'Ausrüstung löschen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Ausrüstung löschen möchten?',
    name: 'Name',
    location: 'Standort',
    quantity: 'Menge',
    drone: 'Drohne',
    photo: 'Foto',
    photoUrl: 'Foto-URL',
    notes: 'Notizen',
    actions: 'Aktionen',
    noEquipment: 'Noch keine Betriebsausrüstung. Fügen Sie Ihre erste Ausrüstung hinzu.',
  },

  // Manufacturing (STD-015 query/mutation error fallbacks)
  manufacturing: {
    failedToCheckAccess: 'Fertigungszugriff konnte nicht überprüft werden',
    failedToLoad:
      'Fertigungsdaten konnten nicht geladen werden. Prüfen Sie, ob die Snapshot-Skripte ausgeführt wurden.',
    failedToLoadPartDetail: 'Teiledetails konnten nicht geladen werden',
    failedToSimulate:
      'Simulation fehlgeschlagen. Stellen Sie sicher, dass das Produkt eine Stückliste hat, und versuchen Sie es erneut.',
  },

  // Flugfreigabe (#1182 Stufe 3) — nur noch der Massen-Dialog je Drohnen-
  // Seriennummer; die Strings des Einzeldatei-Dialogs sind mit ihm in B-6
  // entfallen (STD-029 R-12), siehe en.ts.
  flightShares: {
    selectOrganization: 'Organisation',
    permission: 'Zugriff',
    permissionRead: 'Lesen',
    permissionWrite: 'Lesen + Details bearbeiten',
    permissionHelp:
      'Lesen erlaubt der anderen Organisation, die Fluge zu sehen und herunterzuladen. Lesen + Details bearbeiten erlaubt ihr zusatzlich, die Details jedes Flugs zu bearbeiten (Typ, Pilot, Nutzlast, Kunde, Projekt). Nur Ihre Organisation kann einen Flug loschen.',
    nothingNewToShare: 'Alle passenden Fluge waren bereits freigegeben - nichts zu tun.',
    sharedOne: '1 Flug freigegeben.',
    sharedOther: '{{count}} Fluge freigegeben.',
    skippedOne: '1 war bereits freigegeben.',
    skippedOther: '{{count}} waren bereits freigegeben.',
    droneOwnedBy: 'Gehort {{org}}.',
    droneFlightsOne: '1 von Ihrer Organisation damit erfasster Flug.',
    droneFlightsOther: '{{count}} von Ihrer Organisation damit erfasste Fluge.',
    noShareableDrones: 'Ihre Organisation hat noch keine erfassten Fluge zum Freigeben.',
    onlyAdmins: 'Nur Organisations-Admins konnen Freigaben andern.',
    bulkTitle: 'Fluge einer Drohne freigeben',
    bulkIntro:
      'Gibt alle von Ihrer Organisation erfassten Fluge dieser Drohne in einem Schritt frei statt einzeln. Wiederholbar: bereits freigegebene Fluge werden ubersprungen.',
    drone: 'Drohne',
    fromDate: 'Ab Datum',
    toDate: 'Bis Datum',
    fromDateHelp: 'Leer lassen, um das hinterlegte Ubergabedatum der Drohne zu verwenden.',
    bulkShare: 'Fluge freigeben',
    errors: {
      noSoldDate:
        'Fur Drohne {{serial}} ist kein Ubergabedatum hinterlegt, daher gibt es keine belastbare Trennung zwischen XERs eigenen Flugen vor der Ubergabe und denen des Kunden. Tragen Sie unten unter "Ab Datum" das Ubernahmedatum des Kunden ein.',
      noFlights: 'Keine Fluge Ihrer Organisation entsprachen der Auswahl - nichts freigegeben.',
      illegalPairing:
        'Fluge konnen nur zwischen XER Technologies und einer Kundenorganisation freigegeben werden, in beide Richtungen, niemals zwischen zwei Kunden.',
    },
  },

  objectShares: {
    menuItemFile: 'Datei freigeben...',
    menuItemFolder: 'Ordner freigeben...',
    menuItemMany: '{{count}} Elemente freigeben...',

    dialogTitle: 'Freigabe - {{name}}',
    dialogTitleMany: 'Freigabe von {{count}} Elementen',
    multiSelection:
      'Alle {{count}} ausgewahlten Elemente werden freigegeben. Bestehende Freigaben bleiben erhalten - was bereits fur die gewahlte Organisation freigegeben ist, wird ubersprungen.',
    folderCoversFutureFiles:
      'Wird ein Ordner freigegeben, gilt die Freigabe auch fur seinen gesamten Inhalt, einschliesslich spater hinzugefugter Dateien. Sie mussen neue Dateien nicht einzeln freigeben.',
    currentShares: 'Aktueller Zugriff',
    noShares: 'Dies ist fur niemanden freigegeben.',
    sharedWithOrg: 'Freigegeben fur {{org}}',
    sharedByOrg: 'Fur uns freigegeben von {{org}}',
    sharedDirectionUnknown: 'Freigegeben (Empfanger nicht verfugbar)',
    unknownOrg: 'Eine andere Organisation',
    grantedOn: 'Erteilt am {{date}}',

    revoke: 'Freigabe aufheben',
    revokeConfirm: 'Freigabe dieser Datei fur {{org}} beenden? Der Zugriff endet sofort.',
    revokeConfirmFolder:
      'Freigabe dieses Ordners fur {{org}} beenden? Der Zugriff auf den gesamten Inhalt endet, auch auf seit der Freigabe hinzugefugte Dateien.',
    revokeSuccess: 'Freigabe beendet.',

    shareWith: 'Freigeben fur',
    selectOrganization: 'Organisation',
    permission: 'Zugriff',
    permissionRead: 'Lesen',
    permissionWrite: 'Lesen + Schreiben',
    permissionHelp:
      'Lesen erlaubt der anderen Organisation, diese Datei zu sehen und herunterzuladen. Lesen + Schreiben erlaubt ihr zusatzlich, die Datei umzubenennen. Loschen kann sie nur Ihre eigene Organisation.',
    permissionHelpFolder:
      'Lesen erlaubt der anderen Organisation, den gesamten Ordnerinhalt zu sehen und herunterzuladen, auch spater hinzugefugte Dateien. Lesen + Schreiben erlaubt ihr zusatzlich, darin Ordner anzulegen sowie Elemente umzubenennen und zu verschieben. Hochladen in diesen Ordner ist im Dateibereich noch nicht moglich, weil solche Uploads noch nicht als Fluge verarbeitet wurden. Loschen kann darin nur Ihre eigene Organisation.',
    share: 'Freigeben',
    noCounterparties: 'Es gibt keine Organisation, fur die Sie dies freigeben konnen.',
    sharedOne: '1 Element freigegeben.',
    sharedOther: '{{count}} Elemente freigegeben.',
    skippedOne: '1 war bereits freigegeben.',
    skippedOther: '{{count}} waren bereits freigegeben.',
    onlyAdmins: 'Nur Organisationsadministratoren konnen Freigaben andern.',

    errors: {
      noObjects:
        'Keines der ausgewahlten Elemente gehort Ihrer Organisation - es gab nichts freizugeben.',
      illegalPairing:
        'Dateien konnen nur zwischen XER Technologies und einer Kundenorganisation freigegeben werden, in beide Richtungen, niemals zwischen zwei Kunden.',
    },
  },

  flightLinks: {
    menuItem: 'Mit Flug verknupfen...',
    dialogTitle: 'Mit Flug verknupfen - {{name}}',
    intro:
      'Ein mit einem Flug verknupftes .bin-Log reist mit ihm: jede Organisation, fur die der Flug freigegeben ist, kann das Log offnen und plotten. Aufheben der Verknupfung oder Widerrufen der Flugfreigabe entzieht es wieder.',
    current: 'Verknupft mit',
    noLinks: 'Dieses Log ist mit keinem Flug verknupft.',
    candidates: 'Fluge, zu denen dieses Log gehoren kann',
    day: 'Tag',
    logStart: 'Log gestartet {{time}} (laut Dateiname).',
    noLogStart:
      'Der Dateiname enthalt keine Startzeit, daher ist kein Flug markiert. Wahlen Sie den Tag der Aufzeichnung.',
    noCandidates:
      'Kein sichtbarer Flug der Organisation dieses Logs an diesem Tag. Wahlen Sie einen anderen Tag.',
    proposed: 'Wahrscheinlich',
    deltaLogName: '{{minutes}} min vom CSV-Namen',
    deltaFirstSample: '{{minutes}} min vom ersten Messwert (UTC)',
    flightOn: 'Drohne {{serial}}, {{date}}',
    sharedWith: 'Freigegeben fur {{orgs}}: die Verknupfung gibt ihnen dieses Log',
    sharedWithLinked: 'Freigegeben fur {{orgs}}, die dieses Log offnen konnen',
    notShared: 'Flug nicht freigegeben',
    unknownOrg: 'Andere Organisation',
    link: 'Verknupfen',
    unlink: 'Verknupfung aufheben',
    unlinkConfirm:
      'Verknupfung dieses Logs mit dem Flug aufheben? Organisationen, fur die der Flug freigegeben ist, verlieren sofort den Zugriff auf das Log.',
    linked: 'Verknupft.',
    alreadyLinked: 'Bereits verknupft.',
    unlinked: 'Verknupfung aufgehoben.',
    promptTitle: 'Ist das derselbe Flug?',
    promptQuestion: '{{bin}} und {{flight}} haben fast zur selben Zeit begonnen.',
    promptNo: 'Nein',
    promptYes: 'Ja, das ist derselbe Flug',
  },

  sharedView: {
    navLabel: 'Fur mich freigegeben',
    title: 'Fur mich freigegeben',
    backToFiles: 'Zuruck zu Dateien',
    kindFlights: 'Fluge',
    kindFiles: 'Dateien',
    flightsIntro: 'Fluge, die zwischen Ihrer Organisation und anderen freigegeben sind.',
    flightsIntroDetail:
      'Ein freigegebener Flug enthalt seine Logdatei und alle damit verknupften .bin-Logs, die sich wie jede andere Datei offnen lassen. Was Ihre Organisation freigibt, steht unter "Von uns freigegeben"; was andere fur Sie freigeben, unter "Fur uns freigegeben".',
    filesIntro: 'Dateien und Ordner, die zwischen Ihrer Organisation und anderen freigegeben sind.',
    filesIntroDetail:
      'Die Freigabe eines Ordners umfasst alles darin, auch spater hinzugefugte Dateien - Elemente konnen hier also erscheinen, ohne einzeln freigegeben worden zu sein.',
    aboutThisPage: 'Uber diese Seite',

    outbound: 'Von uns freigegeben',
    inbound: 'Fur uns freigegeben',
    allShares: 'Alle Freigaben',
    filterCounterparty: 'Organisation',
    allCounterparties: 'Alle Organisationen',
    unknownOrg: 'Eine andere Organisation',
    includeRevoked: 'Widerrufene einschliessen',
    openBulk: 'Fluge einer Drohne freigeben',
    onlyAdmins: 'Nur Organisationsadmins konnen Freigaben andern.',

    permissionRead: 'Lesen',
    permissionWrite: 'Lesen + Schreiben',
    droneChip: 'Drohne {{serial}}',
    flightOn: 'Flug {{date}}',
    trackLabel: 'DroneLogbook-Track · {{date}}',
    trackLabelUndated: 'DroneLogbook-Track',
    trackTooltip: 'Ein Flugeintrag aus DroneLogbook, ohne Logdatei.',
    grantedOn: 'Erteilt {{date}}',
    revokedOn: 'Widerrufen {{date}}',
    unnamedEntry: 'Datei nicht verfugbar',

    openFolder: 'Ordner öffnen',
    download: 'Herunterladen',
    downloadStarted: 'Download gestartet.',
    plot: 'In Analytics offnen',
    revoke: 'Freigabe aufheben',
    revokeConfirm:
      'Freigabe fur {{org}} beenden? Der Zugriff endet sofort; bereits abgeleitete Ergebnisse bleiben gultig.',
    revokeSuccess: 'Freigabe beendet.',

    rowsPerPage: 'Elemente pro Seite',
    paginationRange: '{{from}}-{{to}} von {{count}}',
    noneShared: 'Hier ist noch nichts.',
    noneForOrg: 'Keine Freigaben mit dieser Organisation.',
    emptyOutboundFlights:
      'Derzeit sind keine Fluge von Ihrer Organisation freigegeben. Ein Organisationsadmin kann die Fluge einer Drohne auf dieser Seite freigeben.',
    emptyOutboundFiles:
      'Derzeit sind keine Dateien oder Ordner von Ihrer Organisation freigegeben. Freigeben uber das Menu eines Elements unter Dateien.',
    emptyInboundFlights:
      'Derzeit gibt keine Organisation Fluge fur Ihre frei. Fur Sie freigegebene Fluge erscheinen hier, mit ihren Logdateien.',
    emptyInboundFiles: 'Derzeit gibt keine Organisation Dateien oder Ordner fur Ihre frei.',
  },
} as const;
